import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IRiskPotReportAttachmentCategory, IRiskPotReportAttachment } from "../models/IRiskPotReport";

export class RiskPotReportDocumentApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getRiskPotReportAttachmentCategories(success: (data: IRiskPotReportAttachmentCategory[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReportAttachment/categories`, success, error, final);
    }

    uploadFiles(data: IRiskPotReportAttachment[], success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportAttachment/attachments`, data, success, error, final);
    }

    savePhysicalFile(data: IRiskPotReportAttachment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportAttachment/physicalAttachment`, data, success, error, final);
    }

    removeRiskPotReportAttachment(attachmentId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/riskPotReportAttachment/removeAttachment/${attachmentId}`, success, error, final);
    }

    downloadRiskPotReportAttachment(riskPotReportAttachmentId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/riskPotReportAttachment/file/${riskPotReportAttachmentId}`, fileName ?? "", undefined, error);
    }
}
